import {
	TOverviewPeriod,
	TProject,
	TProjectOverview,
	TProjectPayload,
	TProjectSummary,
	TTasksFilters,
} from "@/types";

import API from "./api";

class ProjectsClass {
	getProject = (id: number): Promise<TProject> => {
		return API.get(`projects/${id}`).then((res) => res.data);
	};

	tasksOfProject = (id: number, filters: TTasksFilters) => {
		return API.post(`projects/${id}/tasks`, filters).then(
			(res) => res.data
		);
	};

	/** The projects of the current workspace, or of one client. */
	list = (clientId?: number): Promise<TProject[]> => {
		return API.get("projects", {
			params: clientId ? { client: clientId } : undefined,
		}).then((res) => res.data);
	};

	/**
	 * Every project of the current workspace the caller sees, internal and
	 * archived ones included, with its figures; `period` empty = the
	 * current month. The /projects page's rows.
	 */
	listSummary = (
		period: TOverviewPeriod = {}
	): Promise<TProjectSummary[]> => {
		return API.get("projects/summary", { params: period }).then(
			(res) => res.data
		);
	};

	createProject = (project: TProjectPayload): Promise<TProject> => {
		return API.post("projects", project).then((res) => res.data);
	};

	updateProject = (project: TProjectPayload): Promise<TProject> => {
		return API.patch(`projects/${project.id}`, project).then(
			(res) => res.data
		);
	};

	deleteProject = (id: number) => {
		return API.delete(`projects/${id}`).then((res) => res.data);
	};

	/** 402 when unarchiving would go past the plan's project limit. */
	setProjectArchived = (id: number, archived: boolean) => {
		return API.patch(`projects/${id}/archive`, { archived }).then(
			(res) => res.data
		);
	};

	/** The project page's figures at once; `period` empty = the current month. */
	getOverview = (
		id: number,
		period: TOverviewPeriod = {}
	): Promise<TProjectOverview> => {
		return API.get(`projects/${id}/overview`, { params: period }).then(
			(res) => res.data
		);
	};
}

const ProjectsService = new ProjectsClass();
export default ProjectsService;
